module.exports = __webpack_public_path__ + "static/media/complete_check.dfb4bd82.svg";